import { render, staticRenderFns } from "./ExplanationComponent.html?vue&type=template&id=3153be09&"
import script from "./ExplanationComponent.vue?vue&type=script&lang=ts&"
export * from "./ExplanationComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports